import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import Footer from './Footer/Footer'
import Header from './Header/Header'

// Import Loyalty Swagger Spec
import { BFFAdminSpec } from '../spec/BFFAdminSpec';

export default function SwaggerBFFAdmin() {
  const DisableTryItOutPlugin = function () {
    return {
      statePlugins: {
        spec: {
          wrapSelectors: {
            allowTryItOutFor: () => () => false
          }
        }
      }
    }
  }
  return (
    <div className="App">
      <Header />
      <SwaggerUI spec={BFFAdminSpec} plugins={DisableTryItOutPlugin} />
      <footer className="FooterClass">
        <Footer />
      </footer>
    </div>
  )
}

